/* eslint-disable no-param-reassign */
/* eslint-disable no-console */
import { UserService } from 'gw-capability-gateway';

const PolChangeTrackEvent = ( eventName, isSkipping, endorsementVM, authHeader, props) => {

    try {
        if (eventName === 'Endorsement Step Reached' || eventName === 'Rewrite Step Reached' || eventName === 'Policy Purchased' || eventName === 'Cancel Step Reached' || eventName === 'Rewrite Confirmations Reached') {
            if (!isSkipping) {
                sessionStorage.setItem('pageLoaded', new Date());

                if (sessionStorage.getItem('userSubmitAction') && sessionStorage.getItem('userSubmitted')) {
                    const userSubmitTime = new Date(sessionStorage.getItem('userSubmitted'));
                    const pageLoadTime = new Date();

                    props.system_load_time = (pageLoadTime - userSubmitTime) / 1000;
                    sessionStorage.setItem('userSubmitAction', false);
                    sessionStorage.setItem('lastStep', props.step);
                } 
            }
        }

        if (eventName === 'Endorsement Step Submitted' || eventName === 'Rewrite Step Submitted' || eventName === 'Cancel Step Submitted') {
            sessionStorage.setItem('userSubmitAction', true);
            sessionStorage.setItem('userSubmitted', new Date());

            if (!isSkipping && sessionStorage.getItem('pageLoaded')) {
                const pageLoadTime = new Date(sessionStorage.getItem('pageLoaded'));
                const userSubmitTime = new Date();

                props.user_spent_time = (userSubmitTime - pageLoadTime) / 1000;
                sessionStorage.setItem('lastAction', props.action);
            }
        }

        if (eventName === 'Cancel Step Reached' || eventName === 'Cancel Step Submitted' || eventName === 'Rewrite Step Reached' || eventName === 'Rewrite Step Submitted' || eventName === 'Rewrite Confirmations Reached') {
            props.app_name = 'Producer Engage';
            props.app_parent = 'Agent360';
            props.policyNumber = endorsementVM?.policy.policyNumber?.value;
            props.jobID = endorsementVM?.jobNumber?.value;
            props.bundleIndicator = (endorsementVM?.isUnbundling_ML && endorsementVM?.isUnbundling_ML?.value) ? 'Y' : 'N';
        } else {
            props.pol_state = endorsementVM?.baseData?.value?.policyAddress?.state;
            props.app_name = 'Producer Engage';
            props.app_parent = 'Agent360';
            props.policyNumber = endorsementVM?.policyNumber?.value;
            props.jobID = endorsementVM?.jobID?.value;
            props.bundleIndicator = (endorsementVM?.isBundle_ML && endorsementVM?.isBundle_ML?.value) ? 'Y' : 'N';
        }

        const code =
            endorsementVM.baseData?.value?.productCode ??
            endorsementVM.productCode?.value ??
            '';

        switch (code) {
            case 'HOPHomeowners':
                props.lob = 'Home';
                break;
            case 'PersonalAuto':
                props.lob = 'Auto';
                break;
            default:
                props.lob = '';
        }

        UserService.getCurrentUser(authHeader).then((user) => {  
                props.user_type = user?.userTypeName_ML;
                props.agent_id = user?.userName_ML; 

                window.analytics.track(eventName, props);

          try {
                window.analytics.identify(user.userName_ML, {
                    name: user.displayName,
                    email: user.email,
                    producercode: user.primaryProducerCode_ML?.code,
                    userType: user.userTypeName_ML,
                    pc_username: user.userName_ML,
                    groupName: user.affiliatedGroup_ML?.groupName,
                    login : user.loginID,
                    IAPortalId: user.portalId,
                    pol_state: props.pol_state,
                    lob: props.lob,
                    isCompRater: props.isCompRater,
                    bundleIndicator: props.bundleIndicator,
                    app_page: props.step,
                    Agent_Segment: user.primaryProducerCode_ML?.producerLevel,
                    Transaction_Type: eventName,
                    policyNumber: props.policyNumber,
                    jobID:props.jobID
                });
            } catch (e) {
                console.error(`Segment error calling identify API: ${e.message}`);
            }
        });

        sessionStorage.setItem('segmentProps', JSON.stringify(props));
    } catch (e) {
        console.error(`Segment Error in Track Event: ${e.message}`);
    }
};

export default PolChangeTrackEvent;